import { createNewChat } from 'actions/supportAssistant/supportAssistantActions'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import React from 'react'
import { useIntl } from 'react-intl'

export interface NewChatModalResult {
  triggerLogin: boolean
}

function NewChatModal() {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const modalElement = useModalElementContext<NewChatModalResult>()

  const onLoginToSaveClick = () => {
    modalElement.resolve({ triggerLogin: true })
  }

  const onContinueWithoutSavingClick = () => {
    dispatch(createNewChat())
    modalElement.resolve({ triggerLogin: false })
  }

  return (
    <Modal
      title={intl.formatMessage({
        id: 'Rm4aT1VDsR1ZWeAxoQZM',
        defaultMessage: 'Would you like to save the current chat?',
        description: 'Title for modal asking user to save chat before starting new one',
      })}
      primaryActionText={intl.formatMessage({
        id: 'DYk3zDndcOrtYDB1iRso',
        defaultMessage: 'Login to save chat',
        description: 'Action button label to login and save the current chat',
      })}
      secondaryActionText={intl.formatMessage({
        id: 'tMGjqzfUYGMEJdPYwO6i',
        defaultMessage: 'Continue without saving',
        description: 'Button text to start new chat without saving current one',
      })}
      onPrimaryActionClick={onLoginToSaveClick}
      onSecondaryActionClick={onContinueWithoutSavingClick}
    >
      <BodyText variant="large">
        {intl.formatMessage({
          id: 'JgKpkJBVYcry4UVmpeL1',
          defaultMessage: 'Login to your Luxury Escapes account to save your chats with LESA and access anytime to continue where you left off.',
          description: 'Explanation text encouraging user to login to save chat history',
        })}
      </BodyText>
    </Modal>
  )
}

export default NewChatModal
